module.exports = __webpack_public_path__ + "img/Logos-18.9e8bdcd0.png";